<script>
import api from '@/command/api'
import DetailFormGroup from '@/components/DetailFormGroup'
import Select from '@/components/FormView/FormSelect'
import { getAction } from '@/command/netTool'
import { InputNumber } from 'ant-design-vue'

export default {
  name: 'hotelHomestayDetail',
  data() {
    return {
      ...api.command.getState(),
      detail: {
        roomCouponRuleList: [],
        sort: 0,
        minAmount: null,
        maxAmount: null,
        productQuantityMin: null,
        productQuantityMax: null,
        roomCouponRuleType: '0',
      },
      relationList: [],
    }
  },
  watch: {},
  mounted() {
    const { id } = this.$route.query
    this.getRelationList()
    if (id) {
      api.command.getDetail
        .call(this, {
          url: `/roomCouponRule/detail?id=${id}`,
        })
        .then((res) => {
          this.detail = {
            ...res,
          }
        })
    }
  },
  methods: {
    getRelationList() {
      getAction(`/api/base/farmCouponRule/relationList?giveType=4`).then((result) => {
        this.relationList = result.data
          ? result.data.map((el) => {
              return {
                ...el,
                name: el.couponName,
                value: el.id,
              }
            })
          : []
      })
    },
    getForm1() {
      return {
        title: '模版信息',
        type: 'cardForm',
        data: [
          {
            name: '名称',
            type: 'input',
            cols: 12,
            key: 'name',
            props: {
              maxLength: 40,
            },
            rules: [
              {
                required: true,
              },
            ],
          },
          {
            name: '排序',
            type: 'inputNumber',
            cols: 12,
            key: 'sort',
            maxLength: 35,
          },
          {
            name: '类型',
            type: 'radioButton',
            key: 'roomCouponRuleType',
            cols: 12,
            typeData: [
              {
                name: '金额',
                value: '0',
              },
              {
                name: '数量',
                value: '1',
              },
            ],
            rules: [
              {
                required: true,
              },
            ],
          },
          {
            name: '订单金额区间设置（元）',
            type: 'row',
            cols: 12,
            gutter: 10,
            display: this.detail.roomCouponRuleType == '0',
            rules: [
              {
                required: true,
              },
            ],
            children: [
              {
                label: '最小值',
                type: 'inputNumber',
                cols: 11,
                key: 'minAmount',
                props: {
                  min: 0,
                  addonAfter: '元',
                },
                rules: [
                  {
                    required: true,
                    type: 'number',
                  },
                ],
              },
              {
                type: 'text',
                cols: 2,
                value: '-',
                align: 'center',
              },
              {
                label: '最大值',
                type: 'inputNumber',
                cols: 11,
                key: 'maxAmount',
                props: {
                  min: 0,
                  addonAfter: '元',
                },
                rules: [
                  {
                    required: true,
                    type: 'number',
                  },
                ],
              },
            ],
          },
          {
            name: '房间数量区间设置',
            type: 'row',
            cols: 12,
            gutter: 10,
            display: this.detail.roomCouponRuleType == '1',
            rules: [
              {
                required: true,
              },
            ],
            children: [
              {
                label: '最小值',
                type: 'inputNumber',
                cols: 11,
                key: 'productQuantityMin',
                props: {
                  min: 0,
                  addonAfter: '元',
                },
                rules: [
                  {
                    required: true,
                    type: 'number',
                  },
                ],
              },
              {
                type: 'text',
                cols: 2,
                value: '-',
                align: 'center',
              },
              {
                label: '最大值',
                type: 'inputNumber',
                cols: 11,
                key: 'productQuantityMax',
                props: {
                  min: 0,
                  addonAfter: '元',
                },
                rules: [
                  {
                    required: true,
                    type: 'number',
                  },
                ],
              },
            ],
          },
        ].filter((el) => el.display || el.display === undefined),
      }
    },
    getForm2() {
      return {
        title: '优惠券规则',
        type: 'cardForm',
        data: [
          {
            cols: 24,
            type: 'table',
            showRowSelect: false,
            showPagination: false,
            showFootButton: true,
            dataSource: this.detail.roomCouponRuleList,
            onAddData: () => {
              return {
                couponRuleId: null,
                couponRuleName: null,
                giveNum: null,
              }
            },
            columns: [
              {
                dataIndex: 'couponRuleId',
                align: 'center',
                title: '优惠券',
                type: 'select',
                width: 230,
                customRender: (text, records, index) => {
                  return (
                    <Select
                      item={{
                        name: '优惠券',
                        onChange: (data) => {
                          this.detail.roomCouponRuleList[index].couponRuleId = data
                          this.detail.roomCouponRuleList[index].couponRuleName = this.relationList
                            .filter((e) => data.includes(e.value))
                            .map((e) => {
                              this.detail.roomCouponRuleList[index].giveNum = e.receiveNum
                              this.detail.roomCouponRuleList[index].receiveNum = e.receiveNum
                              return e.name
                            })
                            .toString()

                          this.$forceUpdate()
                        },
                        props: {},
                      }}
                      typeData={this.relationList}
                      value={this.detail.roomCouponRuleList[index].couponRuleId}
                    />
                  )
                },
              },
              {
                dataIndex: 'giveNum',
                align: 'center',
                title: '发放数量（提示：规则的发放数量对应优惠券配置营销活动券的每人领取限额）',
                type: 'select',
                width: 150,
                customRender: (text, records, index) => {
                  return (
                    <InputNumber
                      v-model={this.detail.roomCouponRuleList[index].giveNum}
                      placeholder="数量"
                      min={0}
                      precision={0}
                      style={'width:100%'}
                    />
                  )
                },
              },
              {
                dataIndex: 'a10',
                align: 'center',
                width: 50,
                title: '操作',
                type: 'buttonGroup',
                typeData: ({ records, item, index }) => {
                  return [
                    {
                      name: '删除',
                      popTitle: '确认是否删除吗?',
                      onClick: () => {
                        this.detail.roomCouponRuleList.splice(index, 1)
                      },
                    },
                  ]
                },
              },
            ],
          },
        ],
      }
    },
    /** end 方法 */

    getFoot() {
      const left = [
        {
          name: '提交',
          type: 'primary',
          loading: this.loading,
          sumbit: true,
          display: true,
          onClick: (data) => {
            if (data.roomCouponRuleType == '0' && data.minAmount > data.maxAmount) {
              this.$message.warning('订单金额最小金额应小于最大金额！')
              return
            }
            if (data.roomCouponRuleType == '1' && data.productQuantityMin > data.productQuantityMax) {
              this.$message.warning('房间数量最小数量应小于最大数量！')
              return
            }
            let obj = Object.assign({
              ...data,
            })
            api.command[data.id ? 'edit' : 'create']
              .call(this, {
                url: `/roomCouponRule/${data.id ? 'update' : 'save'}`,
                params: obj,
                isPost: false,
              })
              .then((result) => {
                setTimeout(() => {
                  this.$router.back()
                }, 500)
              })
          },
        },
      ].filter((e) => e.display)
      const right = [
        {
          name: '取消',
          type: 'default',
          onClick: () => this.$router.back(),
          display: true,
        },
        {
          name: '删除',
          popTitle: '确认删除吗?',
          isPop: true,
          type: 'danger',
          ghost: true,
          onClick: () => {
            api.command.del.call(this, {
              url: `/roomCouponRule/delete?id=${this.detail.id}`,
              isPost: false,
            })

            setTimeout(() => {
              this.$router.back()
            }, 500)
          },
          display: this.detail.id,
        },
      ].filter((e) => e.display)
      return {
        left,
        right,
      }
    },
    renderTab() {
      return [this.getForm1(), this.getForm2()]
    },
  },
  render() {
    return (
      <div>
        <DetailFormGroup
          foot={this.getFoot()}
          form={this.detail}
          typeData={{
            linkShopName: this.storeData,
            hotelName: this.typeSearchDataHotel,
          }}
          data={this.renderTab()}
        />
      </div>
    )
  },
}
</script>
<style lang="less" scoped>
</style>
